var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "40%",
            "modal-append-to-body": true,
            "append-to-body": "",
            "close-on-click-modal": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "channelForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "160px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "渠道选择：", prop: "channel" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.channel.channelType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.channel, "channelType", $$v)
                        },
                        expression: "form.channel.channelType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { disabled: "", label: "0" } }, [
                        _vm._v("全部渠道"),
                      ]),
                      _c("el-radio", { attrs: { disabled: "", label: "1" } }, [
                        _vm._v("指定渠道"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.channel.channelType === "1"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        on: {
                          focus: function ($event) {
                            return _vm.channelInputClick(_vm.item)
                          },
                        },
                        model: {
                          value: _vm.form.channel.channelNames,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.channel, "channelNames", $$v)
                          },
                          expression: "form.channel.channelNames",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "端类型", prop: "clientType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.clientType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "clientType", $$v)
                        },
                        expression: "form.clientType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("发端"),
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("收端"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "云镜像封禁", prop: "cloudDeskFlag" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.cloudDeskFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cloudDeskFlag", $$v)
                        },
                        expression: "form.cloudDeskFlag",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "云镜像检测配置", prop: "cloudMirrorFlag" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.cloudMirrorFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cloudMirrorFlag", $$v)
                        },
                        expression: "form.cloudMirrorFlag",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "好友分享检测配置", prop: "friendShareFlag" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.friendShareFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "friendShareFlag", $$v)
                        },
                        expression: "form.friendShareFlag",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "局域网镜像检测配置", prop: "lanMirrorFlag" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.lanMirrorFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "lanMirrorFlag", $$v)
                        },
                        expression: "form.lanMirrorFlag",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "本地音频检测配置", prop: "localAudioFlag" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.localAudioFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "localAudioFlag", $$v)
                        },
                        expression: "form.localAudioFlag",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "本地图片检测配置", prop: "localPicFlag" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.localPicFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "localPicFlag", $$v)
                        },
                        expression: "form.localPicFlag",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "本地视频检测配置", prop: "localVideoFlag" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.localVideoFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "localVideoFlag", $$v)
                        },
                        expression: "form.localVideoFlag",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "在线音频检测配置", prop: "onlineAudioFlag" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.onlineAudioFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "onlineAudioFlag", $$v)
                        },
                        expression: "form.onlineAudioFlag",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "在线图片检测配置", prop: "onlinePicFlag" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.onlinePicFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "onlinePicFlag", $$v)
                        },
                        expression: "form.onlinePicFlag",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "在线视频检测配置", prop: "onlineVideoFlag" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.onlineVideoFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "onlineVideoFlag", $$v)
                        },
                        expression: "form.onlineVideoFlag",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "在线视频域名策略",
                    prop: "onlineVideoDomainStrategy",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.onlineVideoDomainStrategy,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "onlineVideoDomainStrategy", $$v)
                        },
                        expression: "form.onlineVideoDomainStrategy",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-right": "45px" },
                          attrs: { label: "R1" },
                        },
                        [_vm._v("R1")]
                      ),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-right": "45px" },
                          attrs: { label: "R2" },
                        },
                        [_vm._v("R2")]
                      ),
                      _c("el-radio", { attrs: { label: "R3" } }, [
                        _vm._v("R3"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      "show-word-limit": "",
                      maxlength: "9999",
                      type: "textarea",
                      size: "small",
                      placeholder: "请输入备注",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "btn-container",
              staticStyle: { "text-align": "right", "margin-top": "20px" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.save },
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.cancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("channel-popups", {
        attrs: {
          isAppendToBody: true,
          modelIsAppendToBody: false,
          "app-id": _vm.form.channel.channelIds,
          visible: _vm.channelVisible,
          multiple: true,
        },
        on: {
          "update:visible": function ($event) {
            _vm.channelVisible = $event
          },
          comfirm: function ($event) {
            return _vm.channelConfirm($event, _vm.item)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }